import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function UiUxPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'UI/UX – איך לבחור קורס שעובד',
        metaTitle: 'קורס UI/UX עיצוב ממשקים 2025 – Figma, UX Research | Kursi',
        slug: 'ui-ux',
        metaDescription: 'קורסי UI/UX ועיצוב ממשקים 2025 – Figma, User Research, תיק עבודות. מדריך לבחירת קורס UI/UX שמוביל לקריירה. קבלו 3 המלצות קורסים אישיות.',
        subtitle:
          'ב-UI/UX התוצר הוא תיק עבודות. אם הקורס לא מוציא אותך עם 2–3 קייס סטאדיז רציניים — הוא לא מקדם אותך.',
        chips: ['תיק עבודות', 'קייס סטאדי', 'Figma', 'משוב'],
        chatSeed: 'קורס UI UX',
        sections: [
          {
            id: 'portfolio',
            title: 'תיק עבודות לפני הכול',
            body:
              'אל תבחר לפי “מותג”. תבחר לפי תיקי עבודות של בוגרים. זה המדד הכי חד לרמה האמיתית של הקורס.',
            bullets: ['תיקי בוגרים אמיתיים', 'קייס סטאדי מלא', 'הסבר תהליך', 'מיקוד בבעיה עסקית'],
          },
          {
            id: 'process',
            title: 'תהליך מוצר',
            body:
              'UI בלי UX זה ציור. קורס טוב מלמד מחקר בסיסי, אפיון, היררכיות, ואז UI.',
            bullets: ['Research בסיסי', 'אפיון (Flows)', 'Wireframes', 'UI + Design System בסיסי'],
          },
          {
            id: 'feedback',
            title: 'משוב אמיתי',
            body:
              'בלי ביקורת עבודות — אין שיפור. תבדוק מראש איך מתקבל פידבק: תדירות, איכות, ומי נותן אותו.',
            bullets: ['ביקורת שבועית', 'מנטור/ית עם ניסיון', 'קריטריונים ברורים'],
          },
        ],
        checklist: [
          'יש תיקי עבודות של בוגרים (לא רק “דוגמאות”)',
          'יש משוב על עבודות בתדירות גבוהה',
          'יש קייס סטאדי מלא (לא טמפלט)',
          'כלים: Figma + בסיס Design System',
          'יש מדיניות ביטול/החזר הוגנת',
        ],
        redFlags: [
          'UI בלבד בלי תהליך UX',
          'אין ביקורת עבודות',
          'רוב הקורס טמפלטים',
          'אין תוצרים אמיתיים בסוף',
        ],
        faq: [
          { q: 'כמה קייס סטאדיז צריך?', a: 'מינימום 2 רציניים. עדיף 3, אבל איכות > כמות.' },
          { q: 'האם צריך לדעת לצייר?', a: 'לא. צריך חשיבה מוצרית והבנה של משתמשים, היררכיה, וטיפוגרפיה.' },
        ],
      }}
    />
  );
}
